import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMicrosoft365 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "microsoft-365",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M20.3412 20.3333L20.3395 20.3324V3.71762L14.3866 2L3.68508 6.01825L3.6582 6.02347L3.65952 18.0371L7.31143 16.6078V6.83329L14.3866 5.14171L14.3856 19.5128L3.66552 18.0371L14.3856 21.9956V22L20.3395 20.3523V20.3333H20.3412Z",
			fill: "#EA3E23"
		})
	})
});
export default SvgMicrosoft365;
